import {useMemo} from 'react';
import {useAllAgenciesQuery, useAllSellersQuery, useRillUserQuery} from '~/modules/RillAnalytics/queries';
import {PermissionResourceType} from '~/modules/Users/models/UserPermission';

export interface IImpersonatedResourceOption {
    value: number;
    label: string;
}

export const useImpersonatedResourceOptions = (userId: number | null) => {
    const {data: user, isPending: isUserPending} = useRillUserQuery(userId);
    const {data: sellers = [], isPending: isSellersPending} = useAllSellersQuery();
    const {data: agencies = [], isPending: isAgenciesPending} = useAllAgenciesQuery();

    const items: IImpersonatedResourceOption[] = useMemo(() => {
        if (!user) return [];
        const sellerNamesById = new Map(sellers.map(s => [s.id, s.name || `#${s.id}`]));
        const agencyNamesById = new Map(agencies.map(a => [a.id, a.title]));
        return (user.permissions || [])
            .filter(p => p.resourceType === PermissionResourceType.SELLER || p.resourceType === PermissionResourceType.AGENCY)
            .map(p => {
                const isSeller = p.resourceType === PermissionResourceType.SELLER;
                const name = (isSeller ? sellerNamesById.get(p.resourceId) : agencyNamesById.get(p.resourceId)) || `#${p.resourceId}`;
                return {value: p.resourceId, label: `${isSeller ? 'Seller' : 'Buyer'}: ${name}`};
            });
    }, [user, sellers, agencies]);

    return {
        items,
        isPending: userId != null && (isUserPending || isSellersPending || isAgenciesPending)
    };
};
